import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            studentFundingLocalSettingsReceived: 'localSettings/StudentFundingLocalSettings',
        }),
    },
    methods: {
        ...mapActions({
            FetchStudentFundingLocalSettings: 'localSettings/FetchStudentFundingLocalSettings',
        }),
        GetLocalSetting(key) { return this.localSettings?.KeyValuePairs[key] || null; },
        LoadStudentFundingLocalSettings() {
            this.FetchStudentFundingLocalSettings()
                .then(() => this.studentFundingLocalSettings = CoalesceJSON(this.studentFundingLocalSettingsReceived, {}))
                .catch(error => eventBus.$emit('alert:error', error));
        },
    }
};
function CoalesceJSON(object, returnObject) {
    if (object == null) return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
